import React from 'react'
import MyIput from './UI/Button/Input/MyIput'
import MySelect from './UI/Button/Select/MySelect'

export default function FilterAndSearch({filter, setFilter}) {
   return (
      <div className="d-flex justify-content-between my-2">
         <MyIput
            value={filter.query}
            className="form-control"
            onChange={e => setFilter({...filter, query: e.target.value})}
            placeholder="Search"
         />
         <MySelect
            value={filter.sort}
            onChange={selected => setFilter({...filter, sort: selected})}
            defaultValue="Sorted by"
            options={[
               { value: "title", name: "Programming" },
               { value: "body", name: "Jobs" }
            ]}
         />
      </div>
   )
}
